import React from "react";

interface IBarcodeIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const BarcodeIcon: React.FC<IBarcodeIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 5V19M8 5V19M12 5V19M17 5V19M21 5V19" stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
}
